export const getMenuVariables = (
  menuType: string,
  preview: string | undefined,
  abTestVersion: string | null,
  fullMenu: boolean
) => {
  if (preview) {
    const previewParams = preview.split('|')
    return {
      abTestVersion,
      fullMenu,
      menuType: previewParams[0],
      menuVersion: previewParams[1],
    }
  }

  return {
    abTestVersion,
    fullMenu,
    menuType,
  }
}
